(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Base", [], factory);
	else if(typeof exports === 'object')
		exports["Base"] = factory();
	else
		root["Base"] = factory();
})(window, function() {
return 